import { pageViewTypes } from "@constants/tracking";
import {
	FeedbackForm,
	defaultFeedbackSubtitle,
	dialogTexts,
} from "@features/feedback";
import useAnalytics from "@hooks/useAnalytics";
/* -----------------Child components--------------- */
import { Box } from "@memorang/ui";
import ModalHeader from "components/ModalHeader";
/* -----------------Globals--------------- */
import { Stack, useLocalSearchParams, useRouter } from "expo-router";
import { useTranslation } from "react-i18next";

const FeedbackRoute = () => {
	useAnalytics({
		type: pageViewTypes.feedback,
	});

	const { view, itemId } = useLocalSearchParams<{
		view?: string;
		itemId?: string;
	}>();
	const router = useRouter();
	const config = dialogTexts.feedback;
	const { t } = useTranslation();

	const handleDismissFeedback = () => {
		router.back();
	};
	return (
		<>
			<Stack.Screen
				options={{
					presentation: "modal",
					headerShown: true,
					header: () => (
						<ModalHeader backIcon="arrow-left" headerTitle={t(config.title)} />
					),
				}}
			/>
			<Box padding={16}>
				<FeedbackForm
					view={view || "profile"}
					handleDismiss={handleDismissFeedback}
					feedbackSubtitle={t(defaultFeedbackSubtitle)}
					itemId={itemId}
				/>
			</Box>
		</>
	);
};

export default FeedbackRoute;
